import React, { useReducer } from "react";
import { tableReducer, TableState } from ".";
import { TableWrapper } from "./tableWrapper";
import { TableProps } from "./types";

export const TableContext = React.createContext<{
  state: TableState;
  dispatch: any;
}>({
  state: {} as TableState,
  dispatch: null,
});

export const Table: React.FC<TableProps> = (props) => {
  const [state, dispatch] = useReducer(tableReducer, {
    rows: [],
    selectedRows: [],
    searchTerm: "",
    order: (props?.order === "desc") ? props.order : "asc",
    orderBy: 0,
    page: 0,
    rowsPerPage: 10,
    rowsFilterTable: [],
    filtersData: undefined,
  });

  return (
    <TableContext.Provider value={{ state, dispatch }}>
      <TableWrapper {...props}></TableWrapper>
    </TableContext.Provider>
  );
};
